import { MainPage } from './MainPage'

const ShiftManagement = ({ children }: React.PropsWithChildren) => {
  return <MainPage>{children}</MainPage>
}
// I'm exporting this like this to make sure that we make the API of this
// component as explicit as possible and to try to enforce that the public
// interface it has is small.
export { ShiftManagement }
